import React, { FC, useState } from "react";
import LmsTable from "../ui/LmsTable";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import BCModal from "../../ui/BCModal";
import BCButton from "../../ui/BCButton";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import { GlobalConstants } from "../../constants/GlobalConstants";
const WireAnalysis = ({ wireAnalysisModalData }) => {
  return <>{wireAnalysisModalData && wireAnalysisModalData.split("</br>").map(str => <p>{str}</p>)}</>;
};

const LmsAccountingACHQueueMainPage: FC = () => {
  const [isWireAnalysisModalOpen, setIsWireAnalysisModalOpen] = useState(false);
  const [wireAnalysisModalData, setWireAnalysisModalData] = useState("");
  const [{ fetchData }] = useFetchData("");
  const handleModalClose = (): void => setIsWireAnalysisModalOpen(false);
  const handleOpenWireAnalysisModal = async (options) => {
    const checkedItemIds = options?.checkedItems.map(checkedItem => options?.tableData[checkedItem].id);
    const { data, error } = await fetchData("accounting/wire-analysis", { fetchMethod: "PUT", data: checkedItemIds });
    if (data && data !== "") {
      setIsWireAnalysisModalOpen(true);
      setWireAnalysisModalData(data);
    }
    else {
      options?.useFormInstance?.setFormErrorMessage(error);
    }
  };

  const handleAchProcess =  async (options) => {
    const checkedItemIds = options?.checkedItems.map(checkedItem => options?.tableData[checkedItem].id);
    const { data, error } = await fetchData("draws/ach-process", { fetchMethod: "POST", data: checkedItemIds });
      // TODO: Unsure how to make a row.alllowAchid === "No" to test, need to ask Alex
    if (data) {FeatureFlags.IS_DEBUG && console.log("data", data);}
    if (error) {FeatureFlags.IS_DEBUG && console.log("error", error);}
  };

  return (
    <>
      <BCModal
        closeIcon
        onClose={handleModalClose}
        isModalOpen={isWireAnalysisModalOpen}
        content={<WireAnalysis wireAnalysisModalData={wireAnalysisModalData} />}
        actions={<BCButton handleOnClick={handleModalClose}>Ok</BCButton>}
      />
      <LmsTable
        apiSuffix="accounting/ach-queues"
        clearSuffixesOnSuccess={["accounting/ach-queues"]}
        actionButtons={[
          "export",
          {
            text: "Wire Analysis",
            isDisabled: (checkedItems) => checkedItems?.length < 1,
            handleClick: (options) => handleOpenWireAnalysisModal(options)
          },
          { 
            text: "Wire Process",
            isDisabled: (checkedItems) => checkedItems?.length < 1,
            action: "downloadselected",
            downloadSuffix: "draws/wire-process",
            downloadMany: true,
            method: "POST",
            icon: GlobalConstants.Icons.CARET_UP,
            payloadContentType: "JSON",
            refreshDataOnSuccess: true
          },
          { 
            text: "Check Process",
            isDisabled: (checkedItems, tableData) => {
              if (checkedItems?.length < 1) return true;
              let disableCheckProcess = false;
              checkedItems.map(index => {
                if (tableData[index].requiresApprovalForPaymentId === "Yes") disableCheckProcess = true;
              });
              return disableCheckProcess;
            },
            action: "submitselected",
            method: "PUT",
            submitSuffix: "accounting/check-process",
            refreshDataOnSuccess: true
          },
          { 
            text: "ACH Analysis",
            isDisabled: (checkedItems) => checkedItems?.length < 1,
            action: GlobalConstants.TableDefaultActions.DOWNLOAD_SELECTED,
            downloadSuffix: "draws/ach-queue-analysis",
            method: "POST",
            payloadContentType: "JSON",
            downloadMany: true
          },
          { 
            text: "ACH Process",
            isDisabled: (checkedItems, tableData) => {
              if (checkedItems?.length < 1) return true;
              let disableAchProcess = false;
              checkedItems.map(index => {
                if (tableData[index].allowAchid === "No") disableAchProcess = true;
              });
              return disableAchProcess;
            },
            handleClick: (options) => handleAchProcess(options)
          },
          { 
            text: "ACH Sample", 
            // TODO: ran into error "There are no ACH entries to be processed." in old Lms, need to ask Alex
            // TODO: endpoint in Lmsv2 works correctly, error return as json file, test again after Slobodan's code
            isDisabled: (checkedItems) => checkedItems?.length < 1,
            action: GlobalConstants.TableDefaultActions.DOWNLOAD_SELECTED,
            downloadSuffix: "draws/ach-queue-sample-ach",
            method: "POST",
            payloadContentType: "JSON",
            downloadMany: true
          },
          { 
            text: "RBA",
            isDisabled: (checkedItems, tableData) => {
              if (checkedItems?.length < 1) return true;
              let disableRBA = false;
              checkedItems.forEach(index => {
                if (tableData[index].requiresApprovalForPaymentId === "Yes") disableRBA = true;
                if (tableData[index].directPayId === "No") disableRBA = true;
              });
              return disableRBA;
            },
            action: "submitselected",
            method: "PUT",
            submitSuffix: "accounting/ach-rba",
            refreshDataOnSuccess: true
          },
          { 
            text: "Remove RBA",
            isDisabled: (checkedItems, tableData) => {
              if (checkedItems?.length < 1) return true;
              let disableRemoveRBA = false;
              checkedItems.forEach(index => {
                if (tableData[index].directPayId === "No") disableRemoveRBA = true;
                if (tableData[index].requiresApprovalForPaymentId === "No") disableRemoveRBA = true;
              });
              return disableRemoveRBA;
            },
            action: "submitselected",
            method: "PUT",
            submitSuffix: "accounting/ach-remove-rba",
            refreshDataOnSuccess: true
          },
        ]}
        rowBackgroundColor="lightgreen"
        rowBackgroundColorConditionFunc={(row) => row.allowAchid === "Yes"}
        columnLabelsDictionary={{
          loanNumber: "Loan #"
        }}
        skipClick
      />
    </>
  );
};

const LmsAccountingACHQueue = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <LmsAccountingACHQueueMainPage />;
};

export default LmsAccountingACHQueue;
